import { ReactElement } from "react";
import { useHomeContext } from "../../../../pages/Home/HomeContent";
import { WelcomeContentEnum } from "../../../../types/welcome";
import Gap from "../../../atoms/Gap";
import DisplayContent from "../../../molecules/DisplayContent";
import NextPrevButtons from "../../../molecules/NextPrevButtons";
import { usePageBackground } from "../../../../hooks/usePageBackground";

const DisplayStudyDetails = (): ReactElement => {

  const { welcomeData, goPrevious } = useHomeContext();

  const contentData =
    welcomeData?.contents[WelcomeContentEnum.DETAILED_HOME_STUDY].content;

  usePageBackground(
    welcomeData?.contents[WelcomeContentEnum.DETAILED_HOME_STUDY].page_style
  );

  return (
    <DisplayContent
      key="study-details"
      editorJsData={contentData}
      buttonComp={
        <>
          <Gap size="30%"/>
          <NextPrevButtons onPreviousClick={goPrevious} />
        </>
      }
    />
  );
};

export default DisplayStudyDetails;
